import { Icon } from '@design-system';
import Link from 'next/link';
import { FC } from 'react';

import PageSection from '../PageSection';

export type Item = {
  href: string;
  name: string;
};

interface BreadcrumbsListProps {
  items: Item[];
  onClick: (item: Item) => void;
}

export const BreadcrumbsList: FC<BreadcrumbsListProps> = ({
  items,
  onClick,
}) => (
  <section className="z-30 w-full border-b border-divider/20 bg-white">
    <PageSection>
      <div className="flex items-center space-x-1 overflow-x-auto py-4">
        {items.map((item, index) =>
          index < items.length - 1 ? (
            <div key={item.name} className="flex items-center space-x-1">
              <Link
                key={item.name}
                className="link whitespace-nowrap"
                href={item.href}
                onClick={() => onClick(item)}
              >
                {item.name}
              </Link>
              <Icon name="ic_chevron_right" />
            </div>
          ) : (
            <span key={item.name} className="truncate whitespace-nowrap">
              {item.name}
            </span>
          ),
        )}
      </div>
    </PageSection>
  </section>
);
